<template>
  <d-progress :visible="loading"/>
  <d-motion-axis
    v-if="start"
    :selected="type"
    :transition="transition"
    axis="z"
  >
    <template v-slot:notFound>
      <c-not-found/>
    </template>
    <template v-slot:body>
      <div class="c-faq">
        <c-navigation/>
        <div class="c-body px-4 pb-2 lg:px-5">
          <c-header/>
          <c-banner-main v-if="banner" class="max-w-screen-xl"/>
          <div class="c-context gap-5 pb-16 max-w-screen-xl">
            <c-tab class="c-section" :list="section" :selected="path"/>
            <div class="c-none"/>
            <c-article class="pt-5"/>
            <main>
              <div class="pt-5">
                <router-view/>
              </div>
            </main>
          </div>
        </div>
      </div>
    </template>
  </d-motion-axis>
</template>

<script>
import CArticle from '@/components/CArticle'
import CBannerMain from '@/components/CBannerMain'
import CHeader from '@/components/CHeader'
import CNavigation from '@/components/CNavigation'
import CNotFound from '@/components/CNotFound'
import CTab from '@/components/CTab'
import DMotionAxis from 'dcode/components/DMotionAxis'
import DProgress from 'dcode/components/DProgress'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default {
  components: {
    CArticle,
    CBannerMain,
    CHeader,
    CNavigation,
    CNotFound,
    CTab,
    DMotionAxis,
    DProgress
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    store.dispatch('init')

    return {
      loading: computed(() => store.getters.getLoading),
      banner: computed(() => store.getters.isBanner),
      path: computed(() => route.path),
      section: computed(() => store.getters.getSection),
      start: computed(() => store.getters.isBasic),
      type: computed(() => store.getters.getNotFound ? 'notFound' : 'body'),
      transition: computed(() => store.getters.getNotFound ? 'back' : 'next')
    }
  }
}
</script>

<style lang="scss">
.c-faq {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-template-areas:
    "body"
    "nav";
}

nav {
  grid-area: nav;
}

.c-body {
  grid-area: body;
}

.c-context {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-template-areas:
    "section"
    "article"
    "main"
    "none-line";
  grid-area: context;
}

.c-section {
  grid-area: section;
}

.c-none {
  grid-area: none-line;
}

main {
  grid-area: main;
}

article {
  grid-area: article;
}

@media (min-width: 1024px) {
  .c-faq {
    grid-template-columns: 284px auto;
    grid-template-areas: "nav body";
  }
}

@media (min-width: 1280px) {
  .c-context {
    grid-template-columns: auto 284px;
    grid-template-areas:
      "section none-line"
      "main article";
  }
}
</style>
